import { ZodIssueCode, z } from 'zod';

const createReturnObj = (message: string) => ({ message });

export default defineNuxtPlugin((nuxtApp) => {
  z.setErrorMap((issue, ctx) => {
    const { t } = nuxtApp.$i18n as ReturnType<ReturnType<typeof useI18n>>;

    if (issue.code === ZodIssueCode.too_small && ['string', 'array'].includes(issue.type)) {
      return createReturnObj(t(`validations.errors.zod.${issue.type}.too_small`, issue));
    }

    return createReturnObj(ctx.defaultError);
  });
});
